import { render, staticRenderFns } from "./GlbConversionTrigger.vue?vue&type=template&id=f0966ce4&scoped=true&"
import script from "./GlbConversionTrigger.vue?vue&type=script&lang=js&"
export * from "./GlbConversionTrigger.vue?vue&type=script&lang=js&"
import style0 from "./GlbConversionTrigger.vue?vue&type=style&index=0&id=f0966ce4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0966ce4",
  null
  
)

export default component.exports